import { createAsyncAction } from 'typesafe-actions';
import { Timezone } from '@rootCommon/types/glossary';

export const fetchTimezones = createAsyncAction(
  'FETCH_TIMEZONES_REQUEST',
  'FETCH_TIMEZONES_SUCCESS',
  'FETCH_TIMEZONES_FAILURE',
)<undefined, Timezone[], Error>();

export default fetchTimezones;
